import i18next from 'i18next';

import {
  calculateMarginSuccess,
  toggleQuantityHasAPIError,
  toggleQuantityInputHasError,
  updateQuantityInputErrorMessage,
  updateQuantityInputInConts,
} from 'actions/placeorder';
import { isSpotContract } from 'helpers/utils';
import {
  quantityInputHasAPIErrorSelector,
  quantityInputHasErrorSelector,
  quantityInputValue,
} from 'selectors/placeOrderSelector';
import { selectedProductSelector } from 'selectors/tradeSelectors';

import { convertNumberOfContractsToSelectedCurrency } from '../../../formulae';

const resetErrors = () => (dispatch, getState) => {
  const state = getState();
  const quantityInputHasError = quantityInputHasErrorSelector(state);
  const quantityHasAPIError = quantityInputHasAPIErrorSelector(state);
  if (quantityInputHasError || quantityHasAPIError) {
    dispatch(toggleQuantityInputHasError(false));
    dispatch(updateQuantityInputErrorMessage(''));
    dispatch(toggleQuantityHasAPIError(false));
    dispatch(calculateMarginSuccess());
  }
};

const handleError =
  (value, selectedDropdown, side, forceError = false, hasUserTyped = false) =>
  (dispatch, getState) => {
    const state = getState();
    const selectedProduct = selectedProductSelector(state);
    const qtyInput = quantityInputValue(state);
    if ((Number(value) > 0 || value === '' || value === null) && !forceError) {
      dispatch(resetErrors());
    } else if (qtyInput !== null || forceError) {
      const convertedValue = convertNumberOfContractsToSelectedCurrency(
        1,
        selectedProduct ?? {},
        selectedDropdown,
        side
      );

      let quantity = `${convertedValue} ${selectedDropdown}`;

      if (isSpotContract(selectedProduct?.contract_type)) {
        quantity = `${selectedProduct?.contract_value} ${selectedProduct?.contract_unit_currency}`;
      }

      if (
        hasUserTyped &&
        (Number(qtyInput) < Number(convertedValue) ||
          Number(qtyInput) === 0 ||
          Number.isNaN(value))
      ) {
        dispatch(toggleQuantityInputHasError(true));
        dispatch(updateQuantityInputInConts(0));
        dispatch(
          updateQuantityInputErrorMessage(
            i18next.t('errors:placeOrder.orderSizeError', {
              quantity,
            })
          )
        );
      }
    }
  };

export { resetErrors };
export default handleError;
